<template>
    <div id="print-text-label-page">
        <div class="top-buttons">
            <ui5-button @click="onPrint">{{ trans('pages.print_text_label.print') }}</ui5-button>
            <ui5-button @click="$router.push('/menu')">{{ trans('pages.print_text_label.cancel') }}</ui5-button>
        </div>

        <div>
            <ui5-textarea
                :placeholder="trans('pages.print_text_label.input_placeholder')"
                :value="text"
                @input="text = $event.target.value" />
        </div>
    </div>
</template>

<script>
import exportApi from '../api/export';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            text: '',
        };
    },
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
                ]();
        },
    },
    methods: {
        onPrint() {
            const preferredPrinter = this.selectedPrinterPostParameter;

            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printTextLabel(this.text, preferredPrinter)
                    .then(() => {
                        this.text = '';
                        showInfoMessage(this.trans('pages.print_text_label.label_printed'));
                    })
                    .catch(() => {
                        showErrorMessage(this.trans('pages.print_text_label.print_error'));
                    }),
                Config.url + '/export/exportTextLabel/?text=' + encodeURIComponent(this.text)
            );
        },
    },
};
</script>
